import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Route, Switch } from 'react-router-dom';

import Login from 'components/Login';

const ModalView = ({ location, parentPath }) => (
  <TransitionGroup component={null}>
    <CSSTransition
      timeout={300}
      classNames="fade"
      key={location.pathname.split('/')[1]}
    >
      <Switch location={location}>
        <Route path="/(login|password-reset)/(recovery|success)?" exact>
          <Login parentPath={parentPath} />
        </Route>
      </Switch>
    </CSSTransition>
  </TransitionGroup>
);

export default ModalView;
